import { createFileRoute } from '@tanstack/react-router';
import { getGrokImageToVideoSeoData } from '@/components/custom/grok-image-to-video-seo-data';
import { GrokImageToVideoRoute } from '@/components/custom/grok-image-to-video-route';
import { seo } from '@/lib/seo';
import { validateVideoSearch } from '@/lib/video-route-search';

export const Route = createFileRoute('/image-to-video')({
  validateSearch: validateVideoSearch,
  head: () => {
    const data = getGrokImageToVideoSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: GrokImageToVideoRoute,
});
